<section class="main">
    <h1 *ngIf="!statusOfEdit">Add Utility</h1>
    <h1 *ngIf="statusOfEdit">Edit Utility</h1>
    <div *ngIf="!statusOfImage">
        <form>
            <div class="form-group mb-3">
                <label>Name</label>
                <input type="text" [(ngModel)]="uitltyName" name="uitltyName" class="form-control">
            </div>

            <mat-form-field *ngIf="!statusOfEdit">
                <mat-label>Projects</mat-label>
                <mat-select [(ngModel)]="project_id" name="project_id">
                    <mat-option value="{{item.id}}" *ngFor="let item of all_projects">
                        {{item.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="form-group ">
                <label>Unit measure</label>
                <input [(ngModel)]="measure" name="measure" type="text" class="form-control">
            </div>

            <div class="mt-3">
                <mat-slide-toggle [(ngModel)]="disabledApp" name="disabledApp" [color]="color">
                    Disabled in Mobile APP
                </mat-slide-toggle>
            </div>

            <div class="btnSubmit">
                <button *ngIf="!statusOfEdit" class="btn" (click)="addUilty()">Next</button>
                <button *ngIf="statusOfEdit" class="btn" (click)="editUitlty()">Edit Utility</button>
            </div>
        </form>
    </div>
    <div *ngIf="statusOfImage">
        <div class="mt-4">
            <p>Utility image</p>
            <label for="images" class="drop-container">
                <input (change)="uploadUtilityImage($event)" type="file" id="images" accept="image/*" required />
            </label>
        </div>
        <div class="btnSubmit">
            <button class="btn" (click)="addUtiltyImage()">Add Utility</button>
        </div>
    </div>
</section>